import React, { useState } from "react";
import "../../../styles/myTooltip.scss";

type Props = {
  content: React.ReactNode;
  children: React.ReactNode;
  className?: string;
  dataCy?: string;
  dataStatus?: string;
  delay?: number;
  direction?: string;
  tooltipClass?: string;
};

const Tooltip = ({
  children,
  content,
  className,
  dataCy,
  dataStatus,
  delay = 200,
  direction = "top",
  tooltipClass,
}: Props) => {
  let toolTipTimerId: ReturnType<typeof setTimeout> | undefined;

  const [active, setActive] = useState(false);

  const showTip = () => {
    toolTipTimerId = setTimeout(() => {
      setActive(true);
    }, delay);
  };

  const hideTip = () => {
    clearInterval(toolTipTimerId);
    setActive(false);
  };

  return (
    <div
      className={`Tooltip-Wrapper ${className}`}
      data-cy={dataCy}
      data-status={dataStatus}
      // When to show the tooltip
      onMouseEnter={showTip}
      onMouseLeave={hideTip}
    >
      {/* Wrapping */}
      {children}
      {active && (
        <div className={`Tooltip-Tip ${direction} ${tooltipClass} `}>
          {content}
        </div>
      )}
    </div>
  );
};

export default Tooltip;
